import { APIService } from "./index";

export const getCodeGeneratorStatusService =async (projectId) => {
    return await APIService.api().post(`/ComputeStatus/status`,{
        neoAssistProjectId: projectId
      })
}